<template>
        <span v-if="data && ( data.code != '' || data.libelle != '' )">
            <strong>Affaire : </strong>
            <strong v-if="(data.code != '' )">{{ data.code }}</strong>
            <strong v-if="(data.code != '' && data.libelle != '')"> / </strong>
            <strong v-if="(data.libelle != '' )">{{ data.libelle }}</strong>
            <br />
        </span>

</template>

<script>

export default {

    props: {
        data: Object
    }
}
</script>